import { Card, CardContent } from '@/components/ui/card';
import { Hammer, Play, DollarSign } from 'lucide-react';

const StatCard = ({ icon: Icon, iconBg, iconColor, label, value, testId }) => (
  <Card className="bg-white border border-slate-100" data-testid={testId}>
    <CardContent className="p-4">
      <div className="flex items-center gap-3">
        <div className={`w-10 h-10 ${iconBg} rounded-lg flex items-center justify-center`}>
          <Icon className={`h-5 w-5 ${iconColor}`} />
        </div>
        <div>
          <p className="text-sm text-slate-500">{label}</p>
          <p className="text-xl font-bold text-slate-900">{value}</p>
        </div>
      </div>
    </CardContent>
  </Card>
);

/**
 * RenovationStatsCards — 4-card summary row (Total / Active / Budget /
 * Spent). Presentational; parent computes the values.
 */
export const RenovationStatsCards = ({ totalProjects, activeProjects, totalBudget, totalSpent }) => (
  <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
    <StatCard
      icon={Hammer}
      iconBg="bg-blue-100"
      iconColor="text-blue-600"
      label="Total Projects"
      value={totalProjects}
      testId="stat-total-projects"
    />
    <StatCard
      icon={Play}
      iconBg="bg-amber-100"
      iconColor="text-amber-600"
      label="Active Projects"
      value={activeProjects}
      testId="stat-active-projects"
    />
    <StatCard
      icon={DollarSign}
      iconBg="bg-emerald-100"
      iconColor="text-emerald-600"
      label="Total Budget"
      value={`$${totalBudget.toLocaleString()}`}
      testId="stat-total-budget"
    />
    <StatCard
      icon={DollarSign}
      iconBg="bg-red-100"
      iconColor="text-red-600"
      label="Total Spent"
      value={`$${totalSpent.toLocaleString()}`}
      testId="stat-total-spent"
    />
  </div>
);

export default RenovationStatsCards;
